import { PRIVATE_ADMIN } from "Shared/Routing/Application/Constants/PathsConstant";

export const PRIVATE_ADMIN_LIST_SCHEDULED_COMMANDS = PRIVATE_ADMIN + '/list-delegation-service';
export const PRIVATE_ADMIN_FORM_SCHEDULED_COMMAND = PRIVATE_ADMIN + '/form-delegation-service';